export let url = "https://xflix-with-node.herokuapp.com";

export const allVideosParam = "/v1/videos";
export const categories = {
  views: "views",
  votes: "votes",
};
export const upVoteIncrease = {
  vote: "upVote",
  change: "increase",
};
export const upVoteDecrease = {
  vote: "upVote",
  change: "decrease",
};

export const downVoteIncrease = {
  vote: "downVote",
  change: "increase",
};
export const downVoteDecrease = {
  vote: "downVote",
  change: "decrease",
};
